import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const postParsePaymentsCsv =
  (axios: IAxiosInstance) => async (csv: string) => {
    const response = await axios.noRetry.post("/api/processPaymentsCsv", {
      csvData: csv,
    });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error(
      "Error parsing CSV file. Please ensure file matches provided template."
    );
  };
